<template>
  <div class="container">
      <div class="box hour">
        <select name="hour" class="hourSelect" :value='currentHour' v-on:change="onHourChange($event)">
          <option v-for='hour in hours' :key='hour.val' :value='hour.val'>{{hour.val}}</option>
        </select>
      </div>
      <div class="box minute">
        <select name="minute" class="minuteSelect" :value='currentMinute' v-on:change="onMinuteChange($event)">
          <option v-for='minute in minutes' :key='minute.val' :value='minute.val'>{{minute.val}}</option>
        </select>
      </div>
  </div>
</template>

<script>

let createHours = function () {
  const hours = [];
  for (let i = 8; i <= 18; i++) {
    hours.push({'val': i})
  }
  return hours
};

let createMinutes = function () {
  const minutes = [
    { val: '00' }
  ]

  for (let i = 15; i < 60; i += 15) {
    minutes.push({'val': i.toString()})
  }

  return minutes;
}

export default {
  name: 'TimePicker',
  model: {
    prop: 'time',
    event: 'change'
  },
  props: ['time'],
  data () {
    return {
      hours: createHours(),
      minutes: createMinutes(),
    }
  },
  methods: {
    getTime () {
      return `${this.selectedHour}:${this.selectedMinute}`
    },
    onHourChange (event) {
      // console.log('hourChange');
      // this.selectedHour = event.target.value
      const split = this.time.split(':')
      split[0] = event.target.value
      const changed = `${split[0]}:${split[1]}`
      this.$emit('change', changed)
    },
    onMinuteChange (event) {
      // this.selectedMinute = event.target.value
      // console.log('minuteChange');
      const split = this.time.split(':')
      split[1] = event.target.value
      const changed = `${split[0]}:${split[1]}`
      this.$emit('change', changed)
    },
  },
  computed: {
    currentHour () {
      return this.time.split(':')[0]
    },
    currentMinute () {
      return this.time.split(':')[1]
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    display: inline-flex;
    justify-content: space-around;
  }

  .box {
    text-align: center;

    &.minute {
      margin-left: 0.3em;
    }
  }

  select {
    padding: 0.2em 0.8em;
    font-size: 140%;
    box-sizing: border-box;

    border-width: 0 0 1px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TimePicker.vue